import { getOriginalSeller, getOriginalSellerId } from "../inventory";
import { legalUnits } from "../primitives";
import { calculateGroupPricing, calculateItemGroupQuantity, } from "./carts";
import { uniqueArr } from "../util";
export function stringifyQuantity(item) {
    const unit = legalUnits.find((x) => x.key === item.listing.product.unit);
    return `${item.quantity} ${item.quantity === 1 ? unit.name : unit.pluralName}`;
}
/**
 * Create the "details" object which will be used to display per-grower order information on
 * the order list pages
 */
function makeOrderItemDetailsByOriginalSeller({ items, isRetail, fulfillment, applicableTaxes, }) {
    const sellerIds = new Set(items.map((item) => getOriginalSellerId(item.listing)));
    const detailsByOriginalSeller = {};
    for (const sellerId of sellerIds) {
        const sellerItems = items.filter((item) => getOriginalSellerId(item.listing) === sellerId);
        const calculatedPricing = calculateGroupPricing({
            items: sellerItems,
            fulfillment: Object.assign(Object.assign({}, fulfillment), { handlingFeePercent: 0, price: 0 }),
            isRetail,
            applicableTaxes,
        });
        // The first item will always exist due to how we grab the seller ids
        const originalSeller = getOriginalSeller(sellerItems[0].listing);
        detailsByOriginalSeller[sellerId] = {
            sellerDisplayName: originalSeller._cache.bio.displayName,
            calculatedPricing,
            itemCounts: makeItemCounts(sellerItems),
        };
    }
    return detailsByOriginalSeller;
}
export const canViewChildOrder = ({ order, profileId, }) => {
    return (order.buyerId === profileId ||
        order.sellerId === profileId ||
        order.detailsByOriginalSeller[profileId] !== undefined);
};
export const getOrderDetailsBySeller = ({ order, sellerId, }) => {
    if (order.sellerId === sellerId) {
        return {
            itemCounts: order.itemCounts,
            calculatedPricing: order._calculated,
            sellerDisplayName: order.sellerDisplayName,
        };
    }
    const details = order.detailsByOriginalSeller[sellerId];
    if (!details)
        throw new Error("This order is not available to this profile");
    return details;
};
export const filterByOriginalSeller = (sellerId) => (orderItem) => getOriginalSellerId(orderItem.listing) === sellerId;
const hasPositiveQuantity = (item) => item.quantity > 0;
const makeItemCounts = (items) => ({
    unique: items.filter(hasPositiveQuantity).length,
    total: calculateItemGroupQuantity(items),
});
export function getMemoizedOrderFields({ items, fulfillment, applicableTaxes, isRetail, sellerId, }) {
    return {
        _calculated: calculateGroupPricing({
            items,
            fulfillment,
            applicableTaxes,
            isRetail,
        }),
        itemCounts: makeItemCounts(items),
        allSellerIds: uniqueArr([sellerId, ...items.map((item) => getOriginalSellerId(item.listing))]),
        detailsByOriginalSeller: makeOrderItemDetailsByOriginalSeller({
            items,
            fulfillment,
            applicableTaxes,
            isRetail,
        }),
    };
}
//# sourceMappingURL=orders.js.map